export default element => {
    var allFilters = {};
    var allGroups = {};
    var allProducts = [];

    var visibleFilterValues = [];
    var visibleProducts = [];
    var visibleGroups = [];
    var hiddenProducts = [];
    var hiddenGroups = [];

    var showBtn = null;
    var clearBtn = null;

    var showProducts = function () {
        visibleProducts.forEach(function (product) {
            product.element.style.display = "block";
            product.element.removeAttribute("data-loadmore-skip");
        });
        hiddenProducts.forEach(function (product) {
            product.element.style.display = "none";
            product.element.setAttribute("data-loadmore-skip", "");
        });
        visibleGroups.forEach(function (group) {
            allGroups[group].style.display = "block";
            allGroups[group].dispatchEvent(new CustomEvent("update"));
        });
        hiddenGroups.forEach(function (group) {
            if (!visibleGroups.includes(group)) {
                allGroups[group].style.display = "none";
                allGroups[group].dispatchEvent(new CustomEvent("update"));
            }
        });
        // showBtn.hide();

        visibleFilterValues = [];
        Object.keys(allFilters).forEach(function (key) {
            visibleFilterValues.push(key + "=" + allFilters[key].values.join(";"));
        });
    };

    var findProducts = function (filters) {
        var res = [];
        allProducts.forEach(function (product) {
            var visible = true;
            Object.keys(filters).forEach(function (key) {
                var filter = filters[key];
                var values = product.filterValues[key];
                if (values != null && values.length > 0) {
                    if (filter.length > 0) {
                        var v = false;
                        filter.forEach(function (val) {
                            v |= values.includes(val);
                        });
                        visible &= v;
                    }
                } else {
                    visible &= filter.length == 0;
                }
            });
            if (visible)
                res.push(product);
        });
        return res;
    };

    var updateFilterCount = function () {
        var filters = {};
        Object.keys(allFilters).forEach(function (key) {
            filters[key] = allFilters[key].values.slice();
        });

        Object.keys(allFilters).forEach(function (key) {
            var orgValues = filters[key];
            allFilters[key].elements.forEach(function (element) {
                if (element.countElement == null)
                    return;

                filters[key] = [];
                filters[key].push(element.filterValue);

                var products = findProducts(filters);
                element.countElement.innerText = products.length;
            });
            filters[key] = orgValues;
        });
    };

    var updateProducts = function () {
        visibleProducts = [];
        visibleGroups = [];
        hiddenProducts = [];
        hiddenGroups = [];

        var filters = {};
        Object.keys(allFilters).forEach(function (key) {
            filters[key] = allFilters[key].values.slice();
        });

        allProducts.forEach(function (product) {
            product.visible = false;
        });

        var products = findProducts(filters);
        products.forEach(function (product) {
            product.visible = true;
        });

        allProducts.forEach(function (product) {
            if (product.visible) {
                if (!visibleGroups.includes(product.groupId))
                    visibleGroups.push(product.groupId)
                visibleProducts.push(product);
            } else {
                if (!hiddenGroups.includes(product.groupId))
                    hiddenGroups.push(product.groupId)
                hiddenProducts.push(product);
            }
        });

        updateFilterCount();

        var anyFilter = false;
        var visibleFilter = true;
        Object.keys(allFilters).forEach(function (key) {
            visibleFilter &= visibleFilterValues.includes(key + "=" + allFilters[key].values.join(";"));
            anyFilter |= allFilters[key].values.length > 0;
        });

        if (showBtn) {
            showBtn.updateCount();

            if (visibleFilter)
                showBtn.hide();
            else
                showBtn.show();
        }

        if (clearBtn) {
            if (anyFilter)
                clearBtn.show();
            else
                clearBtn.hide();
        }
    };
    var initProducts = function () {
        var groups = element.querySelectorAll("[data-filter-group]");
        Array.prototype.forEach.call(groups, function (group) {
            var groupId = group.getAttribute("data-filter-group");
            if (allGroups[groupId] == null)
                allGroups[groupId] = group;
            var products = group.querySelectorAll("[data-filter-values]");
            Array.prototype.forEach.call(products, function (product) {
                var prod = {
                    groupId: groupId,
                    filterValues: {},
                    element: product,
                    visible: true
                };
                var values = product.getAttribute("data-filter-values").split("|");
                values.forEach(function (val) {
                    var parts = val.split("=");
                    if (parts[1] != "")
                        prod.filterValues[parts[0]] = parts[1].split(";");
                });
                allProducts.push(prod);
            });
        });
    };
    var initFilters = function () {
        var filters = element.querySelectorAll("[data-filter-id]");
        Array.prototype.forEach.call(filters, function (filter) {
            var key = filter.getAttribute("data-filter-id");
            var obj = allFilters[key];
            if (obj == null) {
                allFilters[key] = obj = {
                    key: key,
                    values: [],
                    elements: [],
                    updateValues: function () {
                        var values = [];
                        obj.elements.forEach(function (e) {
                            if (e.checked) {
                                var value = e.filterValue;
                                if (value != "")
                                    values.push(value);
                            }
                        });
                        obj.values = values;
                    }
                };
            }
            filter.filterValue = filter.getAttribute("data-filter-value");
            filter.defChecked = filter.checked;
            if (filter.checked) {
                var value = filter.filterValue;
                if (value != "")
                    obj.values.push(value);
            }
            obj.elements.push(filter);
            filter.countElement = filter.parentElement.querySelector(".filter__count");
            if (filter.type === "checkbox") {
                filter.addEventListener("btn.show", function () {
                    obj.updateValues();
                    updateProducts();
                });
            }
            if (filter.type === "radio") {
                filter.addEventListener("btn.change", function () {
                    obj.values = [];
                    var value = filter.filterValue;
                    if (value != "")
                        obj.values.push(value);
                    updateProducts();
                    showProducts();
                });
            }
        });
    };
    var init = function () {
        showBtn = element.querySelector("[data-show-btn]");

        if (showBtn) {
            showBtn.updateCount = function () {
                showBtn.innerText = showBtn.getAttribute("data-show-btn").replace("{0}", visibleProducts.length);
                showBtn.show();
            };
            showBtn.addEventListener("click", function () {
                showProducts();
            });
            showBtn.show = function () {
                showBtn.style.display = "";
            };
            showBtn.hide = function () {
                showBtn.style.display = "none";
            };
        }

        clearBtn = element.querySelector("[data-clear-btn]");
        if (clearBtn) {
            clearBtn.addEventListener("click", function () {
                Object.keys(allFilters).forEach(function (filter) {
                    allFilters[filter].elements.forEach(function (e) {
                        e.checked = e.defChecked;
                        if (e.defChecked)
                            e.parentElement.classList.add('active');
                        else
                            e.parentElement.classList.remove('active');
                    });
                    allFilters[filter].updateValues();
                });
                updateProducts();
                showProducts();
            });
            clearBtn.show = function () {
                clearBtn.style.display = "";
            };
            clearBtn.hide = function () {
                clearBtn.style.display = "none";
            };
        }

        initProducts();
        initFilters();
        updateProducts();
        showProducts();
    };

    init();
}